import React, { useEffect, useState } from "react";
import Images from "../../Helpers/Images";
import { BsChevronDoubleRight } from "react-icons/bs";
import { MdDeleteForever } from "react-icons/md";
import { Button, Modal, Tab } from "react-bootstrap";
import Sidebar from "./Sidebar";
import Header from "../../Components/comman/Header";
import MobileHeader from "../../Components/comman/MobileHeader";
import Aos from "aos";
import FeaturedBox from "../../Components/comman/FeaturedBox";
import { APIRequest, ApiUrl } from "../../Helpers/ApiHelper";
import { Link } from "react-router-dom";
import { Auth } from "../../Contexts/AuthContext";
import { useContext } from "react";
import { Notification, toaster } from "rsuite";
import CustomLoader from "../../Components/comman/Loader/CustomLoader";
const Wishlist = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const { auth } = useContext(Auth);
  const getWishlistData = () => {
    setIsLoading(true);

    let config = {
      url: ApiUrl.getWishlist,
      method: "GET",
    };

    APIRequest(
      config,
      (res) => {
        setData(res?.data ?? []);
        setIsLoading(false);
      },
      (err) => {
        console.log(err);
        setIsLoading(false);
      }
    );
  };

  // delete wishlist
  const handleDeleteWishlist = () => {
    if (!selectedId) return;
    let config = {
      url: ApiUrl.removeFromWishlist,
      method: "DELETE",
      body: {
        campaign_id: selectedId,
      },
    };
    setIsLoading(true);
    APIRequest(
      config,
      (res) => {
        toaster.push(
          <Notification type="success" header="Success" closable>
            {res ? res.message : "Wishlisted Successfully"}
          </Notification>,
          { placement: "topCenter" }
        );
        setShow(false);
        getWishlistData();
      },
      (err) => {
        toaster.push(
          <Notification type="error" header="Error" closable>
            {err?.response?.data?.message ||
              "Failed to update wishlist status."}
          </Notification>,
          { placement: "topCenter" }
        );
        console.log(err);
      }
    );
  };
  useEffect(() => {
    Aos.init({});
    getWishlistData();
  }, []);
  const handleClose = () => setShow(false);
  return (
    <div className="main-pages-wrapper">
      <Header />
      <MobileHeader />
      <CustomLoader visible={isLoading} />
      <div className="wishlist-main-wrapper">
        <Tab.Container activeKey={`wishlist`}>
          <Sidebar />
          <div className="wishlist-wrapper">
            <Tab.Content>
              <Tab.Pane eventKey={"wishlist"}>
                <div className="wishlist-inner">
                  <h6 className="heading-title">My Wishlist</h6>
                  <div className="wishlists-wrap">
                    {data?.map((item, index) => (
                      <div
                        className="wishlist-box"
                        data-aos="fade-up"
                        data-aos-duration="2000"
                        key={`wishlistItem${index}`}
                      >
                        {/* {console.log("wishlistItem", item?.id)} */}
                        <Link
                          to="/campagin-detail"
                          state={{ product: item?.campaign, from: "wishlist" }}
                          className="wishlist-box-inner"
                        >
                          <div className="collab-product-box-img">
                            <img
                              src={item?.campaign?.campaign_logo_url}
                              alt="product-img"
                            />
                          </div>
                          <div className="wishlist-content">
                            <div className="heading">
                              <h6 className="product-name">
                                {item?.campaign?.brand?.company_name}
                              </h6>
                              <p className="p-title">
                                {item?.campaign?.campaign_title}
                              </p>
                            </div>
                            <div className="social-platform-box-w-wrapper">
                              <div className="social-Platform-w">
                                <p>Platforms</p>
                                <span>
                                  {item?.campaign?.campaign_platform?.map(
                                    (platform, index) => (
                                      <img
                                        key={index}
                                        src={
                                          platform?.logo
                                            ? platform.logo
                                            : "/default-platform.png"
                                        }
                                        alt={platform?.name}
                                        style={{
                                          width: "22px",
                                          height: "22px",
                                          objectFit: "contain",
                                          marginRight: 5,
                                        }}
                                      />
                                    )
                                  )}
                                </span>
                              </div>
                              <div className="list-name">
                                <span>Residence</span>
                                {item?.campaign?.countries?.map(
                                  (country, index) => (
                                    <img
                                      className="countryFlag"
                                      key={index}
                                      src={
                                        country?.flag_url
                                          ? country.flag_url
                                          : "/default-platform.png"
                                      }
                                    />
                                  )
                                )}
                              </div>
                            </div>
                            <div className="list-wrapper">
                              <div className="list-name">
                                <span>Followers</span>
                                <span className="title">
                                  {" "}
                                  {
                                    item?.campaign?.campaign_platform[0]
                                      ?.social_engagement_data?.follower
                                  }
                                  +
                                </span>
                              </div>
                              <div className="list-name">
                                <span>Engagement</span>
                                <span className="title">
                                  {
                                    item?.campaign?.campaign_platform[0]
                                      ?.social_engagement_data?.engagement
                                  }
                                  % +
                                </span>
                              </div>
                              <div className="list-name">
                                <span>Age</span>
                                <span className="title">
                                  {" "}
                                  {item?.campaign?.age?.min}-
                                  {item?.campaign?.age?.max}+
                                </span>
                              </div>
                            </div>
                          </div>
                        </Link>
                        <Button
                          className="delete-list"
                          onClick={() => {
                            setSelectedId(item?.campaign_id);
                            setShow(true);
                          }}
                        >
                          <MdDeleteForever />
                        </Button>
                      </div>
                    ))}
                    {data.length <= 0 && (
                      <p>
                        Your wishlist is empty. Please add Campaign from
                        Collaboration Hub.
                      </p>
                    )}
                  </div>
                  <h6 className="heading-title">Featured Collaborations</h6>
                  <FeaturedBox />
                  {/* <button className="see-more-btn">
                    See More <BsChevronDoubleRight />
                  </button> */}
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="deleteWishlist-modal"
      >
        <Modal.Body>
          <p className="ConfirmationTxt">
            Are You Sure You Want To Delete This Campaign From Your List ?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClose} className="no-btn">
            No
          </Button>
          <Button className="yes-btn" onClick={handleDeleteWishlist}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Wishlist;
